/**
 * initSearchDrawer()
 *
 * Handles the sticky search button in the search drawer used in mobile view.
 * When clicks the sticky button, it submits the main search form inside the drawer.
 */

export default function initSearchDrawer() {
    const drawer = document.getElementById('drawer-search');
    if (!drawer) return;
    
    const submitBtn = drawer.querySelector('.drawer-search-submit');
    if (submitBtn) {
        submitBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const form = drawer.querySelector('form');
            if(form) form.submit();
        });
    }
}
